import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-box-processing',
  templateUrl: './status-box-processing.component.html',
  styleUrls: ['./status-box-processing.component.scss'],
  standalone: false
})
export class StatusBoxProcessingComponent {
  @Input()
  textContent = '';

  @Input()
  spanId = '';
}
